module.exports = __webpack_public_path__ + "img/ask2travel-logo.41dffab2.png";